import { makeStyles, Theme } from '@material-ui/core/styles'

export const useGlobalStyles = makeStyles((theme: Theme) => ({
  containerPages: {
    width: '100%',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
    padding: '0 24px 24px 24px',
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(14),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(6)
    },
    [theme.breakpoints.only('md')]: {
      marginTop: theme.spacing(12)
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(12),
      padding: '0 48px 48px 48px'
    },
    [theme.breakpoints.up('xxl')]: {
      width: '60%',
      margin: '0 auto',
      padding: theme.spacing(16, 0)
    }
  },
  titleSection: {
    ...theme.typography.h3,
    color: theme.palette.primary.contrastText,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    whiteSpace: 'pre-line',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    }
  },
  containerSectionsHome: {
    width: '100%',
    backgroundColor: theme.palette.background.default,
    padding: '24px 24px 24px 24px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      padding: '48px 48px 24px 48px'
    },
    [theme.breakpoints.up('xxl')]: {
      padding: theme.spacing(3, 70)
    }
  },
  titleSectionsHome: {
    ...theme.typography.h3,
    color: theme.palette.primary.contrastText,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(0.6),
    alignSelf: 'flex-start',
    whiteSpace: 'pre-line',
    maxWidth: '500px'
  },
  titleSectionVariant2: {
    ...theme.typography.h4,
    color: theme.palette.primary.contrastText,
    alignSelf: 'flex-start',
    fontSize: '2rem',
    fontWeight: 500,
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem'
    }
  },
  topPageBreadcrumbsSearch: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start',
      gap: theme.spacing(2)
    }
  }
}))
